import { Box, Button, Drawer, Stepper, Step } from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { onlyNumber } from "assets/js/common";
import AlertTimer from "components/ui/alert-timer";
import axios from "axios";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AlertComplete from "components/ui/alert-complete";
import DrawerComplete from "components/ui/drawer-complete";
import { getCryptoPwd } from "assets/js/common";
import { Cookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import { getAppData } from "assets/js/apphandle";

export default function NewPwd(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [activeStep2, setActiveStep2] = useState(0);
  const [no, setNo] = useState("");
  const cookies = new Cookies();
  const authToken = cookies.get("X-AUTH-TOKEN");

  const inputRef = useRef(null);

  const [step, setStep] = useState(1);

  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleAlertTimerClose = () => {
    setOpenAlert(false);
  };

  const {
    register,
    getValues,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      pwd: "",
      pwdChk: "",
    },
  });

  watch("pwd", false);
  watch("pwdChk", false);

  const savePassword = () => {
    const hashedPw = getCryptoPwd(getValues("pwd"));
    const user = jwt_decode(authToken);
    axios
      .post("/api/mb/member/modify-pwd", {
        no: user.no,
        pwd: hashedPw,
      })
      .then((res) => {
        if (res.data.data) {
          setOpen(true);
        }
      });
  };

  useEffect(() => {
    setValue("pwd", onlyNumber(getValues("pwd")));
    setActiveStep(getValues("pwd").length);
    if (getValues("pwd").length == 6) {
      setStep(2);
    }
  }, [watch("pwd")]);

  useEffect(() => {
    setValue("pwdChk", onlyNumber(getValues("pwdChk")));
    setActiveStep2(getValues("pwdChk").length);
    if (getValues("pwdChk").length == 6) {
      if (getValues("pwd") == getValues("pwdChk")) {
        //   TODO 비밀번호 업데이트
        savePassword();
      } else {
        setOpenAlert(true);
        setValue("pwdChk", "");
      }
    }
  }, [watch("pwdChk")]);

  return (
    <>
      {step == 1 ? (
        <>
          <p className="text-top">새로운 비밀번호를 입력해 주세요</p>
          <div className="stepper-cont">
            <div className="stepper-pw">
              <Stepper activeStep={activeStep} alternativeLabel>
                {Array.from(Array(6)).map((_, index) => (
                  <Step key={index} />
                ))}
              </Stepper>
              <input
                type="tel"
                id="ghostInput1"
                {...register("pwd")}
                autoComplete="off"
                className="ghost-input"
                maxLength="6"
                autoFocus
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <p className="text-top">한번 더 입력해 주세요</p>
          <div className="stepper-cont">
            <div className="stepper-pw">
              <Stepper activeStep={activeStep2} alternativeLabel>
                {Array.from(Array(6)).map((_, index) => (
                  <Step key={index} />
                ))}
              </Stepper>
              <input
                type="tel"
                id="ghostInput2"
                {...register("pwdChk")}
                autoComplete="off"
                className="ghost-input"
                maxLength="6"
                autoFocus
              />
            </div>
          </div>

          <AlertTimer
            open={openAlert}
            handleAlertTimerClose={handleAlertTimerClose}
            text={"일치하지 않습니다."}
          />
        </>
      )}
      <DrawerComplete
        open={open}
        handleDrawerClose={() => {
          handleAlertClose();
          history.goBack();
        }}
        text={"간편 비밀번호가 변경되었습니다."}
        callback={() => {}}
      />
    </>
  );
}
